// extracted by mini-css-extract-plugin
export default {"mobileWidth":"980px","desktopWidth":"1520px","root":"topAward_root__kwKAb","title":"topAward_title__x9hlo"};